var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-block-editor find-contacts" }, [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("automation.findContacts"))),
        ]),
        _vm._v(" "),
        _c("AutomationContactSelector", {
          model: {
            value: _vm.clone.filterGroups,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "filterGroups", $$v)
            },
            expression: "clone.filterGroups",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.findContactsOffset"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Offset",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.offset,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "offset", $$v)
            },
            expression: "clone.offset",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("automation.offsetDesc")) +
              "\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v(_vm._s(_vm.$t("auto.findContactsLimit"))),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Limit",
            "show-attributes": true,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.limit,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "limit", $$v)
            },
            expression: "clone.limit",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("automation.limitDesc")) +
              "\n        "
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }